var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDxdaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.666 125.666C180.777 70.5549 262.105 57.6385 329.505 86.9169L294.333 122.089C247.291 108.669 194.57 120.481 157.526 157.525C108.563 206.488 103.68 282.838 142.878 337.263L195.178 284.963L227.037 316.823L142.56 401.3C136.702 396.715 131.059 391.727 125.666 386.334C53.6846 314.352 53.6846 197.647 125.666 125.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.495 425.083C249.895 454.361 331.223 441.445 386.334 386.334C458.315 314.352 458.315 197.647 386.334 125.666C380.941 120.273 375.298 115.285 369.44 110.7L284.963 195.177L316.823 227.037L369.122 174.737C408.32 229.162 403.437 305.512 354.475 354.474C317.431 391.519 264.709 403.331 217.667 389.911L182.495 425.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86 256L256 224.141L224.141 256L256 287.859L287.86 256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.178 163.318L227.037 195.177L195.178 227.037L163.318 195.177L195.178 163.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.682 316.822L316.823 284.963L284.963 316.822L316.823 348.682L348.682 316.822Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 69.68,
    y: 69.68,
    width: 372.64,
    height: 372.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 256) rotate(90) scale(256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D5AFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDxdaoIcon);
export default __webpack_public_path__ + "static/media/dxdao-icon.fbfb7ea95188994f13c376b868389e3e.svg";
export { ForwardRef as ReactComponent };